import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { FirstMortgageBalanceComponent } from '../first-mortgage-balance/first-mortgage-balance.component';

/**
 * FRU-24835: the reverse flow's balance question. Many reverse borrowers own the home outright, so the "No mortgage" choice
 * (a $0 balance, shown on every balance step since FRU-24242) matters here. The slider starts on its first stop, and since
 * FRU-24230 has no $0 stop, so $0 comes only from "No mortgage" or a typed 0. It is the refinance balance step otherwise,
 * but its "No mortgage" records its own event, not the refinance step's goal.
 */
@Component({
    selector: 'app-reverse-balance',
    templateUrl: '../first-mortgage-balance/first-mortgage-balance.component.html',
    styleUrls: ['../first-mortgage-balance/first-mortgage-balance.component.scss', '../../step/step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class ReverseBalanceComponent extends FirstMortgageBalanceComponent implements OnInit {
  title = 'About how much do you still owe on your mortgage?';

  /** The slider starts on its first stop ("$60,000 and under"), not at half the home value: half sits on the over-50% LTV line
   *  a reverse lead can't be sold past. Back to this step still shows the amount the visitor chose (initStep). */
  initializeData() {
    super.initializeData();
    this.sliderValue = 0;
    this.sliderDisplay = this.sliderLabels[0];
  }

  ngOnInit() {
    this.initializeData();
    this.control = this.form.contains('firstMortgageBalance')
      ? this.form.get('firstMortgageBalance') as UntypedFormControl
      : new UntypedFormControl('', Validators.required);
    if (!this.form.contains('firstMortgageBalance')) { this.form.addControl('firstMortgageBalance', this.control); }
  }

  noMortgage(): void {
    this.analyticsService.trackEvent('RatesForm', 'reverse_paid_off', 'reverse');
    this.countVisitorAction();
    this.enterFieldValue = 0;
    this.enterStringFieldValue = '0';
    this.sliderValue = 0;
    this.sliderDisplay = this.noMortgageLabel;
    this.submit(0);
  }
}
